import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Rooms from "@/pages/Rooms";
import RoomDetail from "@/pages/RoomDetail";
import About from "@/pages/About";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Catalog from "@/pages/Catalog";
import CatalogBook from "@/pages/CatalogBook";
import Collection from "@/pages/Collection";
import { Toaster } from "@/components/ui/sonner";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import ProfileQuiz from "@/pages/ProfileQuiz";
import ResetPassword from "@/pages/ResetPassword";
import Community from "@/pages/Community";
import Topic from "@/pages/Topic";
import WallPost from "@/pages/WallPost";
import PublicProfile from "@/pages/PublicProfile";
import { AuthCallback } from "@/components/AuthCallback";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";

const AppRoutes = () => {
  const location = useLocation();
  // Returning from Google sign-in: exchange session_id before any other route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explorar" element={<Explore />} />
        <Route path="/salas" element={<Rooms />} />
        <Route path="/salas/:id" element={<RoomDetail />} />
        <Route path="/catalogo" element={<Catalog />} />
        <Route path="/catalogo/revista" element={<CatalogBook />} />
        <Route path="/coleccion" element={<Collection />} />
        <Route path="/que-es-mutoni" element={<About />} />
        <Route path="/mi-historia" element={<Navigate to="/que-es-mutoni#mi-historia" replace />} />
        <Route path="/proyecto" element={<Navigate to="/que-es-mutoni#proyecto" replace />} />
        <Route path="/noticias" element={<News />} />
        <Route path="/noticias/:id" element={<NewsDetail />} />
        <Route path="/comunidad" element={<Community />} />
        <Route path="/comunidad/tema/:id" element={<Topic />} />
        <Route path="/comunidad/pared/:id" element={<WallPost />} />
        <Route path="/u/:handle" element={<PublicProfile />} />
        <Route path="/entrar" element={<Login />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/perfil/cuestionario" element={<ProfileQuiz />} />
        <Route path="/restablecer" element={<ResetPassword />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
  );
};

function App() {
  return (
    <LangProvider>
    <AuthProvider>
    <BrowserRouter>
      <SmoothScroll />
      <div className="grain" aria-hidden="true" />
      <Header />
      <AppRoutes />
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </BrowserRouter>
    </AuthProvider>
    </LangProvider>
  );
}

export default App;
